// extracted by mini-css-extract-plugin
export var wrapperStyle = "sr_image_wrapper-module--wrapperStyle--UOf8+";